export const SERVER_URL = "https://drovn.pythonanywhere.com";



// WEBPACK FOOTER //
// ./src/utils/config.js